export default {
  changed_by: 'Ændret af',
  changed_at: 'Ændrings tidspunkt',
  class_room: 'Klasse eller stue',
  year: 'Årgang',
  institution: 'Institution',
  yes: 'Ja',
  no: 'Nej',
  number_of_selected: '{number} ud af {total} valgt',
  not: 'ikke',
  locked: 'låst',
  title: 'Titel',
  category: 'Kategori',
  description: 'Beskrivelse',
  child: 'Barn',
  created: 'Oprettet',
  edited: 'Redigeret',
  last_edited: 'Sidst redigeret',
  children_metadata: '{name} ({metadata})',
  children_summary:
    '@:label.children_metadata | @:label.children_metadata <b>+ @:label.other</b> | @:label.children_metadata <b>+ @:label.others</b>',
  and: 'og',
  other: '1 anden',
  others: '{count} andre',
  fold_out: 'Fold ud',
  share: 'Del',
  export: 'Eksporter',
  day: 'dag',
  daily: 'dagligt',
  never: 'Aldrig',
  weekly: 'Ugentligt',
  every_other_week: 'Hver anden uge',
  month: 'i måneden',
  occur: 'Forekommer',
  every: 'hver',
  end_after: 'og slutter efter {total} gentagelser',
  and_end: 'og slutter efter',
  number_of_weeks: '1 uge | {count} uger',
  number_of_months: '1 måned | {count} måneder',
  deleted: 'Slettet',
  all: 'Alle',
  unread: 'Ulæste',
  filter_locked: 'Låste',
  search_by_child: 'Søg efter barn',
  search_by_category: 'Søg efter kategori',
  employee_profile: 'Medarbejderprofiler',
  week_number: 'Uge {number}',
  active: 'Aktiv',
  deactivated: 'Deaktiveret',
  unfold: 'Fold alle ud',
  number_of_comments: '1 kommentar | {count} kommentarer',
  number_of_unread: '1 ulæst | {count} ulæste',
  created_by: 'Oprettet af {name}',
  label_created_by: 'Oprettet af',
  co_hosted_by: 'Medarrangeret af {name}',
  invitees: 'Inviterede',
  number_of_days: '1 dag | {count} dage',
  number_of_hours: '1 time | {count} timer',
  number_of_minutes: '1 minut | {count} minutter',
  specify_number_of_adults: 'Angiv antal voksne',
  specify_number_of_children: 'Angiv antal børn',
  warning: 'Advarsel',
  regarding: 'Vedrører',
  adjust_expired_date: 'Justér synlig til {option}',
  chosen_expired_date: 'Synlig til dato {expireDate}',
  created_date: 'Oprettelsesdato',
  sort_by_album_name: 'Navn',
  sort_by_newest_media: 'Nyeste medier',
  sort_first: 'først',
  sort_last: 'sidst',
  sort_a_z: 'a til z',
  sort_z_a: 'z til a',
  sort_asc: 'stigende',
  sort_dsc: 'faldende',
  select_more: 'Vælg flere',
  select_all: 'Vælg alle',
  total_selected: '{count} valgt',
  member_of: 'Medlemmer af {name}',
  members: '{count} medlem | {count} medlemmer',
  the: 'det | de',
  new: 'Ny',
  aula_info: 'Aulainfo',
  aula_info_help: 'Få hjælp til Aula',
  aula_info_help_short: 'Hjælp til Aula',
  operating_status_info: 'Informationer om driftstatus',
  note: 'Bemærk',
  remark: 'Bemærkning',
  at: 'kl.',
  by: 'af',
  name: 'Navn',
  repeat: 'Gentag',
  time: 'Tider',
  recurrence_end_date: 'Slutdato for gentagelse',
  select_recurrence_end_date: 'Vælg slutdatoen for gentagelse',
  none: 'Ingen',
  from: 'fra',
  until: 'indtil',
  repeated_weekly: 'Gentages ugentligt',
  repeated_on_even_weeks: 'Gentages i lige uger',
  repeated_on_odd_weeks: 'Gentages i ulige uger',
  repeated_weekly_from: '@:label.repeated_weekly @:label.from uge {weekNumber}',
  repeated_on_even_weeks_from: '@:label.repeated_on_even_weeks @:label.from uge {weekNumber}',
  repeated_on_odd_weeks_from: '@:label.repeated_on_odd_weeks @:label.from uge {weekNumber}',
  search_results_for: 'Søgeresultater for',
  filter_result: 'Filtrer resultater',
  persons: 'Personer',
  groups: 'Grupper',
  number_of_groups: '1 gruppe | {count} grupper',
  secure_files: 'Sikre filer',
  secure_files_imported: 'Sikre importerede filer',
  common_files: 'Fælles filer',
  messages: 'Beskeder',
  calendar: 'Kalender',
  posts: 'Opslag',
  media: 'Medier',
  gallery: 'Galleri',
  results: 'resultat | resultater',
  no_results: 'Ingen resultater fundet',
  aula_groups: 'Aula gruppe',
  cross_groups: 'Tværgående gruppe',
  show: 'Viser',
  sort: 'Sortér',
  sort_newest_first: 'Nyeste først',
  sort_oldest_first: 'Ældste først',
  for: 'for',
  shown: 'vis',
  hidden: 'skjul',
  not_specified: 'Ikke angivet',
  user: 'Bruger',
  date: 'Dato',
  action: 'Handling',
  version: 'Version',
  search_for_groups: 'Søg efter grupper',
  group_home_admin_add_user: 'CPR nummer eller brugernavn',
  back_to_aula: 'Tilbage til Aula',
  back_to_admin: 'Tilbage til Admin',
  administrator: 'Administrator',
  otp: 'Officielt tilknyttet person',
  matched_search: 'Matchende søgeord',
  view_more: 'Vis mere',
  attach_file: 'Vedhæft fil',
  plus: 'plus',
};
